/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RateOfPerceivedExertionType = 'VeryLight' | 'Light' | 'Moderate' | 'Hard' | 'VeryHard';

export const RateOfPerceivedExertionType = {
    VeryLight: 'VeryLight' as RateOfPerceivedExertionType,
    Light: 'Light' as RateOfPerceivedExertionType,
    Moderate: 'Moderate' as RateOfPerceivedExertionType,
    Hard: 'Hard' as RateOfPerceivedExertionType,
    VeryHard: 'VeryHard' as RateOfPerceivedExertionType
};

